import { render, staticRenderFns } from "./CharityRun.vue?vue&type=template&id=55e12696&scoped=true"
import script from "./CharityRun.vue?vue&type=script&lang=js"
export * from "./CharityRun.vue?vue&type=script&lang=js"
import style0 from "./CharityRun.vue?vue&type=style&index=0&id=55e12696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e12696",
  null
  
)

export default component.exports